export default {
	login (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/staff/login', params)
	},
	logout (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/staff/logout', params)
	},
	check (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/staff/check', params)
	},
	current (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/staff/current', params)
	},
	changePassword (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/staff/change_password', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/StaffAuth.js